import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ServiceTicketDialogComponent } from '../service-ticket-dialog/service-ticket-dialog.component';
import { HelpdeskService } from '@services/helpdesk/helpdesk.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'service-ticket',
    templateUrl: './service-ticket.component.html',
    styleUrls: ['./service-ticket.component.scss'],
    providers: [HelpdeskService],
    standalone: false
})

export class ServiceTicketComponent {
  constructor(public dialog: MatDialog, private helpdeskService: HelpdeskService, private snackbar: SnackbarService) {
  }

  async addTicket() {
    const dialogRef = this.dialog.open(ServiceTicketDialogComponent, { width: '600px', height: 'auto', panelClass: 'service-ticket-modal' });
    const result = await dialogRef.afterClosed().toPromise();
    if (result) {
      await this.helpdeskService.createTicket(result.title, result.description);
      this.snackbar.success('Service ticket added');
    }
  }
}
